export default "__VITE_ASSET__rVpK65Ml__"